<template>
  <exchangeHome></exchangeHome>
</template>
<script>
export default {
  components: {
    exchangeHome: () => import("@/components/HQ/exchange/ExchanceHome.vue"),
  },
};
</script>
